export const getIsValidateDisabled = (
	canGoNextStep: boolean,
	allowInvalidSubmit: boolean,
): boolean => {
	if (allowInvalidSubmit) {
		return false;
	}

	return canGoNextStep === false;
};
